import { Icon, IconProps } from "@chakra-ui/react";

export function BINIcon({ ...rest }: IconProps) {
  return (
    <Icon
      width="24px"
      height="24px"
      viewBox="0 0 56 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g clipPath="url(#clip0_416_814)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.10599 0C2.30399 0 0.0329895 2.272 0.0329895 5.074V58.915C0.0329895 61.718 2.30399 63.989 5.10599 63.989H50.88C53.681 63.989 55.954 61.718 55.954 58.915V20.31L37.051 0L5.10599 0Z"
          fill="#7A8F9A"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M56.001 20.357V21.357H43.201C43.201 21.357 36.889 20.097 37.073 14.65C37.073 14.65 37.281 20.357 43.076 20.357H56.001Z"
          fill="#5B6971"
        />
        <path
          opacity="0.5"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M37.098 0.00598145V14.567C37.098 16.223 38.202 20.358 43.202 20.358H56.002L37.098 0.00598145Z"
          fill="white"
        />
        <path
          d="M15.61 39C15.214 39 14.908 38.898 14.692 38.694C14.488 38.478 14.386 38.172 14.386 37.776V27.534C14.386 27.138 14.488 26.838 14.692 26.634C14.908 26.418 15.214 26.31 15.61 26.31H19.93C20.818 26.31 21.574 26.442 22.198 26.706C22.822 26.97 23.296 27.348 23.62 27.84C23.956 28.332 24.124 28.92 24.124 29.604C24.124 30.372 23.902 31.02 23.458 31.548C23.014 32.076 22.408 32.43 21.64 32.61V32.34C22.528 32.472 23.218 32.808 23.71 33.348C24.202 33.888 24.448 34.59 24.448 35.454C24.448 36.582 24.064 37.458 23.296 38.082C22.54 38.694 21.484 39 20.128 39H15.61ZM16.6 37.254H19.84C20.656 37.254 21.256 37.098 21.64 36.786C22.024 36.462 22.216 35.982 22.216 35.346C22.216 34.698 22.024 34.218 21.64 33.906C21.256 33.594 20.656 33.438 19.84 33.438H16.6V37.254ZM16.6 31.692H19.534C20.326 31.692 20.914 31.542 21.298 31.242C21.694 30.93 21.892 30.474 21.892 29.874C21.892 29.274 21.694 28.824 21.298 28.524C20.914 28.212 20.326 28.056 19.534 28.056H16.6V31.692ZM27.9306 39.144C27.5586 39.144 27.2706 39.042 27.0666 38.838C26.8746 38.622 26.7786 38.328 26.7786 37.956V27.354C26.7786 26.97 26.8746 26.676 27.0666 26.472C27.2706 26.268 27.5586 26.166 27.9306 26.166C28.3026 26.166 28.5846 26.268 28.7766 26.472C28.9806 26.676 29.0826 26.97 29.0826 27.354V37.956C29.0826 38.328 28.9866 38.622 28.7946 38.838C28.6026 39.042 28.3146 39.144 27.9306 39.144ZM32.9387 39.144C32.5907 39.144 32.3207 39.048 32.1287 38.856C31.9487 38.664 31.8587 38.388 31.8587 38.028V27.318C31.8587 26.946 31.9487 26.664 32.1287 26.472C32.3207 26.268 32.5667 26.166 32.8667 26.166C33.1427 26.166 33.3467 26.22 33.4787 26.328C33.6227 26.424 33.7907 26.592 33.9827 26.832L40.8767 35.778H40.4087V27.264C40.4087 26.916 40.4987 26.646 40.6787 26.454C40.8707 26.262 41.1407 26.166 41.4887 26.166C41.8367 26.166 42.1007 26.262 42.2807 26.454C42.4607 26.646 42.5507 26.916 42.5507 27.264V38.064C42.5507 38.4 42.4667 38.664 42.2987 38.856C42.1307 39.048 41.9027 39.144 41.6147 39.144C41.3387 39.144 41.1167 39.09 40.9487 38.982C40.7927 38.874 40.6187 38.7 40.4267 38.46L33.5507 29.514H34.0007V38.028C34.0007 38.388 33.9107 38.664 33.7307 38.856C33.5507 39.048 33.2867 39.144 32.9387 39.144Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_416_814">
          <rect width="56" height="64" fill="white" />
        </clipPath>
      </defs>
    </Icon>
  );
}

export function GenericFileIcon({
  colors = ["#7A8F9A", "#5B6971", "white"],
  ...rest
}: IconProps & { colors?: [string, string, string] }) {
  return (
    <Icon
      width="24px"
      height="24px"
      viewBox="0 0 56 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g clipPath="url(#clip0_1202_793)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.10599 0C2.30399 0 0.0329895 2.272 0.0329895 5.074V58.915C0.0329895 61.718 2.30399 63.989 5.10599 63.989H50.88C53.681 63.989 55.954 61.718 55.954 58.915V20.31L37.051 0L5.10599 0Z"
          fill={colors[0]}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M56.001 20.3571V21.3571H43.201C43.201 21.3571 36.889 20.0971 37.073 14.6501C37.073 14.6501 37.281 20.3571 43.076 20.3571H56.001Z"
          fill={colors[1]}
        />
        <path
          opacity="0.5"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M37.098 0.00610352V14.5671C37.098 16.2231 38.202 20.3581 43.202 20.3581H56.002L37.098 0.00610352Z"
          fill={colors[2]}
        />
      </g>
      <defs>
        <clipPath id="clip0_1202_793">
          <rect width="56" height="64" fill={colors[2]} />
        </clipPath>
      </defs>
    </Icon>
  );
}

export function JSONFileIcon(props: IconProps) {
  return (
    <Icon
      width="24px"
      height="24px"
      viewBox="0 0 56 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_1202_807)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.10599 0C2.30399 0 0.0329895 2.272 0.0329895 5.074V58.915C0.0329895 61.718 2.30399 63.989 5.10599 63.989H50.88C53.681 63.989 55.954 61.718 55.954 58.915V20.31L37.051 0L5.10599 0Z"
          fill="#B09443"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M56.001 20.357V21.357H43.201C43.201 21.357 36.889 20.097 37.073 14.65C37.073 14.65 37.281 20.357 43.076 20.357H56.001Z"
          fill="#15442A"
        />
        <path
          opacity="0.5"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M37.098 0.00598145V14.567C37.098 16.223 38.202 20.358 43.202 20.358H56.002L37.098 0.00598145Z"
          fill="white"
        />
        <path
          d="M5.828 39.126C5.492 39.138 5.228 39.048 5.036 38.856C4.844 38.664 4.748 38.418 4.748 38.118C4.748 37.89 4.82 37.692 4.964 37.524C5.096 37.344 5.294 37.248 5.558 37.236L6.098 37.2C6.626 37.164 7.022 37.002 7.286 36.714C7.562 36.414 7.7 35.988 7.7 35.436V27.336C7.7 26.952 7.796 26.664 7.988 26.472C8.192 26.268 8.48 26.166 8.852 26.166C9.224 26.166 9.506 26.268 9.698 26.472C9.902 26.664 10.004 26.952 10.004 27.336V35.418C10.004 36.174 9.866 36.816 9.59 37.344C9.326 37.872 8.93 38.286 8.402 38.586C7.874 38.874 7.22 39.042 6.44 39.09L5.828 39.126ZM17.1233 39.18C16.5953 39.18 16.0673 39.138 15.5393 39.054C15.0113 38.982 14.5133 38.868 14.0453 38.712C13.5773 38.544 13.1573 38.34 12.7853 38.1C12.5693 37.956 12.4193 37.782 12.3353 37.578C12.2513 37.374 12.2213 37.176 12.2453 36.984C12.2813 36.78 12.3593 36.606 12.4793 36.462C12.6113 36.306 12.7733 36.21 12.9653 36.174C13.1573 36.138 13.3673 36.192 13.5953 36.336C14.1233 36.648 14.6813 36.876 15.2693 37.02C15.8573 37.164 16.4753 37.236 17.1233 37.236C18.0713 37.236 18.7613 37.08 19.1933 36.768C19.6253 36.444 19.8413 36.03 19.8413 35.526C19.8413 35.106 19.6853 34.776 19.3733 34.536C19.0733 34.296 18.5513 34.098 17.8073 33.942L15.8273 33.528C14.6873 33.288 13.8353 32.886 13.2713 32.322C12.7193 31.746 12.4433 30.99 12.4433 30.054C12.4433 29.466 12.5633 28.932 12.8033 28.452C13.0433 27.972 13.3793 27.558 13.8113 27.21C14.2553 26.862 14.7773 26.598 15.3773 26.418C15.9893 26.226 16.6613 26.13 17.3933 26.13C18.1133 26.13 18.7973 26.22 19.4453 26.4C20.0933 26.58 20.6753 26.844 21.1913 27.192C21.3833 27.324 21.5093 27.486 21.5693 27.678C21.6413 27.87 21.6593 28.062 21.6233 28.254C21.5873 28.434 21.5033 28.59 21.3713 28.722C21.2393 28.854 21.0713 28.932 20.8673 28.956C20.6753 28.98 20.4533 28.92 20.2013 28.776C19.7573 28.524 19.3073 28.344 18.8513 28.236C18.3953 28.128 17.9033 28.074 17.3753 28.074C16.8233 28.074 16.3493 28.152 15.9533 28.308C15.5573 28.464 15.2513 28.686 15.0353 28.974C14.8313 29.25 14.7293 29.58 14.7293 29.964C14.7293 30.396 14.8733 30.744 15.1613 31.008C15.4493 31.26 15.9413 31.458 16.6373 31.602L18.5993 32.016C19.7873 32.268 20.6693 32.664 21.2453 33.204C21.8333 33.744 22.1273 34.464 22.1273 35.364C22.1273 35.94 22.0073 36.462 21.7673 36.93C21.5393 37.398 21.2033 37.8 20.7593 38.136C20.3273 38.472 19.8053 38.73 19.1933 38.91C18.5813 39.09 17.8913 39.18 17.1233 39.18ZM29.7928 39.18C28.5688 39.18 27.4948 38.91 26.5708 38.37C25.6588 37.83 24.9508 37.074 24.4468 36.102C23.9428 35.118 23.6908 33.966 23.6908 32.646C23.6908 31.65 23.8348 30.756 24.1228 29.964C24.4108 29.16 24.8188 28.476 25.3468 27.912C25.8868 27.336 26.5288 26.898 27.2728 26.598C28.0288 26.286 28.8688 26.13 29.7928 26.13C31.0288 26.13 32.1028 26.4 33.0148 26.94C33.9268 27.468 34.6348 28.218 35.1388 29.19C35.6428 30.162 35.8948 31.308 35.8948 32.628C35.8948 33.624 35.7508 34.524 35.4628 35.328C35.1748 36.132 34.7608 36.822 34.2208 37.398C33.6928 37.974 33.0508 38.418 32.2948 38.73C31.5508 39.03 30.7168 39.18 29.7928 39.18ZM29.7928 37.2C30.5728 37.2 31.2328 37.02 31.7728 36.66C32.3248 36.3 32.7448 35.778 33.0328 35.094C33.3328 34.41 33.4828 33.594 33.4828 32.646C33.4828 31.206 33.1588 30.09 32.5108 29.298C31.8748 28.506 30.9688 28.11 29.7928 28.11C29.0248 28.11 28.3648 28.29 27.8128 28.65C27.2608 28.998 26.8348 29.514 26.5348 30.198C26.2468 30.87 26.1028 31.686 26.1028 32.646C26.1028 34.074 26.4268 35.19 27.0748 35.994C27.7228 36.798 28.6288 37.2 29.7928 37.2ZM39.3176 39.144C38.9696 39.144 38.6996 39.048 38.5076 38.856C38.3276 38.664 38.2376 38.388 38.2376 38.028V27.318C38.2376 26.946 38.3276 26.664 38.5076 26.472C38.6996 26.268 38.9456 26.166 39.2456 26.166C39.5216 26.166 39.7256 26.22 39.8576 26.328C40.0016 26.424 40.1696 26.592 40.3616 26.832L47.2556 35.778H46.7876V27.264C46.7876 26.916 46.8776 26.646 47.0576 26.454C47.2496 26.262 47.5196 26.166 47.8676 26.166C48.2156 26.166 48.4796 26.262 48.6596 26.454C48.8396 26.646 48.9296 26.916 48.9296 27.264V38.064C48.9296 38.4 48.8456 38.664 48.6776 38.856C48.5096 39.048 48.2816 39.144 47.9936 39.144C47.7176 39.144 47.4956 39.09 47.3276 38.982C47.1716 38.874 46.9976 38.7 46.8056 38.46L39.9296 29.514H40.3796V38.028C40.3796 38.388 40.2896 38.664 40.1096 38.856C39.9296 39.048 39.6656 39.144 39.3176 39.144Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_1202_807">
          <rect width="56" height="64" fill="white" />
        </clipPath>
      </defs>
    </Icon>
  );
}
